import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../../pages/home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const cuando = [
  { emoji: "🚪", title: "Puertas grandes a terraza", desc: "Ideales para salones con salida a terraza. Se abren y cierran fácilmente para pasar con bandejas, sillas o incluso carritos de bebé." },
  { emoji: "🛋️", title: "Ventanales del salón", desc: "Para ventanales amplios donde una enrollable no sería práctica. Corren suavemente sobre raíles superiores e inferiores." },
  { emoji: "🍳", title: "Cocinas con salida exterior", desc: "Perfectas para cocinas que dan a patio o tendedero. Permiten ventilar mientras cocinas sin que entren mosquitos." },
];

const sistema = [
  { icon: "ri-arrow-left-right-line", title: "Raíles superior e inferior", desc: "La tela se desliza entre dos raíles de aluminio que guían el movimiento. No se sale ni se desfasa con el uso." },
  { icon: "ri-lock-line", title: "Cierre magnético o pestillo", desc: "El marco móvil se cierra con imanes ocultos o pestillo manual. Queda firme y no se abre con el viento." },
  { icon: "ri-scissors-cut-line", title: "A medida sin límite de ancho", desc: "Podemos fabricar mosquiteras correderas de cualquier ancho, uniendo varios módulos para puertas panorámicas." },
];

const materiales = [
  { name: "Fibra de vidrio estándar", desc: "Malla fina y resistente. Bloquea mosquitos y deja pasar la brisa. Ideal para cualquier uso.", tag: "Estándar" },
  { name: "Poliéster reforzado", desc: "Más económico y ligero. Perfecto para ventanales de interior o protección básica.", tag: "Económico" },
  { name: "Anti-polen grueso", desc: "Malla extra densa. Bloquea polen, mosquitos diminutos y polvo fino. Recomendado para alérgicos.", tag: "Alérgicos" },
];

const faqs = [
  { q: "¿Funcionan en puertas de terraza grandes?", a: "Sí, son la mejor opción. Podemos hacer módulos de hasta 1,5m de ancho cada uno y unir varios para cubrir puertas panorámicas de 3 o 4 metros." },
  { q: "¿El raíl inferior estropea el suelo?", a: "No. El raíl inferior es muy bajo (solo 5mm de alto) y se instala encastrado o atornillado. No supone obstáculo ni para personas ni para mascotas." },
  { q: "¿Se pueden instalar en puertas que ya tienen mosquitera enrollable?", a: "Sí, aunque normalmente sustituimos la enrollable por la corredera si la puerta es grande. La corredera es más robusta y práctica para uso frecuente." },
  { q: "¿Cuánto tarda la instalación?", a: "Entre 1 y 2 horas dependiendo del tamaño. Puertas grandes con varios módulos pueden llevar hasta 3 horas." },
  { q: "¿Se pueden dejar abiertas durante el invierno?", a: "Sí, puedes desmontar el panel móvil en invierno y dejar solo el fijo, o dejarla puesta todo el año. La tela no se deteriora por el frío." },
];

export default function MosquiterasCorrederas() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Mosquiteras Correderas Málaga | Puertas y Ventanales"
        description="Mosquiteras correderas en Málaga para puertas y ventanales grandes. Ideales para terrazas y cocinas. Presupuesto gratis. ☎ 951 12 07 70"
        canonical="/mosquiteras/mosquiteras-correderas/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Mosquiteras", path: "/mosquiteras" }, { name: "Mosquiteras correderas" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[55%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Para puertas y ventanales
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Mosquiteras Correderas en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Para puertas y ventanas correderas grandes. Ideales para salones, cocinas y terrazas. Sistema de raíles suave y duradero.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Desde 90€</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Raíles de aluminio</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Cierre magnético</span>
                </div>
              </div>
              <div className="w-full lg:w-[45%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop"
                    alt="Mosquitera corredera en puerta de terraza Málaga"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CUÁNDO ELEGIRLAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Cuándo elegir mosquiteras correderas?</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {cuando.map((c, i) => (
                <motion.div
                  key={c.title}
                  className="bg-white rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-4xl mb-4">{c.emoji}</div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{c.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{c.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* SISTEMA RAÍLES */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Sistema de raíles</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary mt-4 max-w-2xl mx-auto">
                Las guías superiores e inferiores hacen que la mosquitera corra suave y no se desfase con el tiempo.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {sistema.map((s, i) => (
                <motion.div
                  key={s.title}
                  className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-secondary/10 text-secondary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${s.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{s.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{s.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* MATERIALES */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Materiales y colores</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {materiales.map((m, i) => (
                <motion.div
                  key={m.name}
                  className="bg-white rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="absolute top-0 right-0 bg-primary text-white font-body font-semibold text-xs px-3 py-1 rounded-bl-lg">
                    {m.tag}
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-3 mt-2">{m.name}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{m.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIO */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Precio orientativo</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="max-w-xl mx-auto bg-surface-alt rounded-3xl p-8 md:p-12 text-center shadow-sm">
              <div className="font-heading font-extrabold text-5xl md:text-6xl text-primary mb-2">90-200 €</div>
              <p className="font-body text-lg text-text-secondary mb-6">según tamaño y materiales</p>
              <div className="flex flex-col gap-3 text-left max-w-sm mx-auto">
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Marco de aluminio lacado</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Raíles superiores e inferiores</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Tela fibra de vidrio o poliéster</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Instalación y ajuste incluidos</div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Preguntas frecuentes</h2>
                <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              </div>
              <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-white rounded-2xl p-6 md:p-8"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-text-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-white mb-4">
              ¿Necesitas una mosquitera corredera?
            </h2>
            <p className="font-body text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
              Medimos tu puerta o ventanal gratis y te damos presupuesto al momento.
            </p>
            <a
              href="tel:+34951120770"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors"
            >
              <span>📞</span> Llámanos: 951 12 07 70
            </a>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}